export const PageText = {
  _1: 'Outdoor',
  _2: 'Empower your customers with top air quality information in order to plan or track their activities. Sport and outside exercise are healthy. aircheckr helps to keep it like that!',
  _3: 'Integrate aircheckr into your service',
  _4: 'Knowing that many of your customers are actively looking after their health, air quality information is an important asset. Integrate aircheckr into your service now.'
};

export const Categories = {
  _1: {
    title: "Applications",
    subcategories: [
      {
        key: 0,
        subtitle: 'Healthiest route',
        text: '“I bring my daughter to school with a bike everyday. That\'s healthy, right?  Maybe there is a healthier route?”'
      },
      {
        key: 1,
        subtitle: 'Healthiest moment',
        text: '“Knowing that when I exercise I am more sensitive towards bad air, so what is the best moment to exercise?”'
      },
      {
        key: 2,
        subtitle: 'Track my route',
        text: '“I already track my route, can\'t I also know the air quality along my route?”'
      }
    ]
  },
  _2: {
    title: 'Outdoors & air quality',
    subcategories: [
      {
        key: 0,
        subtitle: 'Unhealthy combination',
        text: 'While outside exercise is one of the keys to a healthy lifestyle, air pollution and exercise can be an unhealthy combination. This is especially true for people with asthma, diabetes, heart or lung conditions, or lower respiratory disease. When people exercise they usually inhale more air and breathe it in more deeply. In addition, while exercising, they are more likely to breathe through their mouth rather than their nose. Unlike nose, mouth is unable to filter out certain (large) pollutants in the air and stop them from entering the lungs.'
      }
    ]
  },
  _3: {
    title: 'The aircheckr solution',
    subcategories: [
      {
        key: 0,
        subtitle: 'Don’t stop exercising!',
        text: 'Sport and outside exercise remain healthy, especially if also the air we breathe is taken into account. aircheckr helps your customers calculate the healthiest route or gives an indication on the best time to put on their sports shoes. For tracking applications, the air quality statistics of the executed trajectory is an additional asset!'
      }
    ]
  }
};

export const Quotes = [{
  key: 0,
  text: 'Changing your route to a healthier one can decrease encounter with specific pollutants by up to 50-75%',
  author: 'Ben Barratt, King’s College London'
},
{
  key: 1,
  text: 'When we exercise, the volume of air pumped by the lungs can be eight times higher the amount pumped at rest.',
  author: 'European Lung Foundation'
}];

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/outdoor_page.js